import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6da1b3c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "row title" }
const _hoisted_3 = { class: "row" }

import StoryList from "@/components/TeamStory/StoryList.vue";
import { useTeamStoryStore } from "@/stores/teamStory";
import LoadingDots from "@/components/util/LoadingDots.vue";
import { onMounted, reactive } from "vue";
import { getQueryParamByName } from "@/common/util";
import router from "@/router";
import { useTeamStore } from "@/stores/team";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  props: {
    template: {}
  },
  setup(__props: any) {

const teamStoryStore = useTeamStoryStore();
const teamStore = useTeamStore();

const props = __props;

const state = reactive({
  teamName: "",
});

onMounted(async () => {
  await teamStoryStore.loadTeamStory(props.template);
  if (teamStoryStore.getTeamStories.length > 0) {
    if (!teamStore.getTeamName)
      await teamStore.fetchTeamInfo(teamStoryStore.getTeamStories[0].targetCode);
    if (teamStore.getTeamName) state.teamName = teamStore.getTeamName;
    else state.teamName = "Unknown";
  }
});


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", null, _toDisplayString(state.teamName), 1),
        _createVNode(_component_router_link, { to: { name: 'Create' } }, {
          default: _withCtx(() => [
            _createElementVNode("button", null, [
              _createVNode(_component_font_awesome_icon, { icon: "fa fa-plus" }),
              _createTextVNode(" New")
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!_unref(teamStoryStore).getLoadingStatus)
        ? (_openBlock(), _createBlock(StoryList, {
            key: 0,
            stories: _unref(teamStoryStore).getTeamStories
          }, null, 8, ["stories"]))
        : (_openBlock(), _createBlock(LoadingDots, { key: 1 }))
    ])
  ], 64))
}
}

})